import { render } from "./LingJiang.vue?vue&type=template&id=ca894a0e&scoped=true"
import script from "./LingJiang.vue?vue&type=script&lang=js"
export * from "./LingJiang.vue?vue&type=script&lang=js"

import "./LingJiang.vue?vue&type=style&index=0&id=ca894a0e&scoped=true&lang=stylus"

import exportComponent from "/Users/test/Desktop/source/work/H5-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca894a0e"]])

export default __exports__